import {TrialService} from '../trial.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {createEffect, Actions, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {map, switchMap, tap, catchError, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as fromApp from './../../../store/app.reducers';

import * as TrialActions from './trial.actions';
import * as ErrorActions from '../../../error/store/error.actions';

import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Cookie} from '../../../helper/cookie';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class TrialEffects {

  addAudit = createEffect(() => this.actions$
    .pipe(
      ofType(TrialActions.ADD_TRIAL_USER_WITH_AUDIT),
      map(
        (data: {type: string, payload: { profile: string, userUid: string }}) => {
          return data.payload;
        }
      ),
      switchMap(
        (params: { profile: string, userUid: string }) => {
          return this.trialService.addTrialAudit(params.profile, params.userUid).pipe(
            mergeMap(
              (response: any) => {
                // audit/:id/waiting/:code
                const cookie = new Cookie();
                const version = +cookie.getCookie('auditor-version');
                const url = ['/audit', response.profile.id, 'waiting', response.certificate.code];
                if (version === 2) {
                  this.router.navigate(url);
                } else if (version === 4) {
                  this.router.navigate(['/user/register/type']);
                } else if (version === 3) {
                  this.router.navigate(['/user/register/type']);
                } else {
                  this.router.navigate(url);
                }
                // this.notifierService.notify('success', 'Audit has been added');
                const actions = [];
                actions.push({
                  type: TrialActions.SET_TRIAL_STEP_PARAM,
                  payload: {
                    stepName: 'audit',
                    paramName: 'url',
                    value: url
                  }
                });
                return actions;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  constructor(
    private actions$: Actions,
    private trialService: TrialService,
    private router: Router,
    private notifierService: ToastrService,
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,

  ) {}
}
